import { render, staticRenderFns } from "./DashboardDoc.vue?vue&type=template&id=6be6c3bc"
import script from "./DashboardDoc.vue?vue&type=script&lang=js"
export * from "./DashboardDoc.vue?vue&type=script&lang=js"
import style0 from "./DashboardDoc.vue?vue&type=style&index=0&id=6be6c3bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports